<template>
  <div>
    <label
      v-if="label"
      :for="id"
      :class="[error ? labelError : labelValid]"
      class="w-full cursor-pointer text-sm pl-1"
    >{{ label }}</label>
    <textarea
      :value="value"
      :type="type"
      @input="input"
      :id="id"
      :placeholder="placeholder"
      :rows="rows"
      :maxlength="maxlength"
      :minlength="minlength"
      :class="[error ? inputError : inputValid]"
      class="outline-none w-full border focus:shadow-inner rounded p-2 text-black leading-tight"
    ></textarea>
    <p v-if="info && !error" class="text-sm text-blue-8 pl-1">{{ info }}</p>
    <p v-if="error" class="text-sm text-red-8 pl-1">{{ error }}</p>
  </div>
</template>

<script>
export default {
  name: "TextArea",
  props: {
    value: {
      required: true
    },
    id: {
      required: true
    },
    errors: {
      required: true
    },
    rows: {
      default: 4
    },
    placeholder: {
      default: null
    },
    type: {
      default: "text"
    },
    label: {
      default: null
    },
    info: {
      default: null
    },
    maxlength: {
      default: null
    },
    minlength: {
      default: null
    }
  },
  data() {
    return {
      labelValid: "text-blue-8",
      labelError: "text-red-8",
      inputValid: "border-grey-5 hover:border-blue-7 focus:border-blue-9",
      inputError: "border-red-5 hover:border-red-7 focus:border-red-9"
    }
  },
  computed: {
    error() {
      return this.errors.has(this.id) ? this.errors.first(this.id) : false
    }
  },
  methods: {
    input(e) {
      this.errors.clear(this.id)
      this.$emit("input", e.target.value)
    }
  }
}
</script>
